import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	aside: {
		position: 'absolute',
		left: 0,
		bottom: 0,
		margin: theme.spacing(2),
		backgroundColor: theme.palette.secondary,
		color: theme.palette.background.paper,

		'& p': {
			margin: 0,
			marginTop: theme.spacing(0.5),
		},
	},
	weatherIconContainer: {
		width: '100%',
		'& svg': {
			display: 'block',
			margin: '0 auto',
			width: 'inherit',
			maxWidth: 768,
			maxHeight: '60vh',
		},
	},
	text: {
		color: theme.palette.background.paper,
		margin: theme.spacing(2),
	},
}));

export default useStyles;
